import { Drawer } from 'antd';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
// Largura definida pela prop `width` de quem usa (ver theme/drawerWidth).
// Espaçamentos e alturas de campo vêm do tema — sem overrides aqui.
export const EditClientDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: 16px 20px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }
  .ant-form-item-label > label {
    font-weight: 600;
    color: var(--yrm-text);
  }
`;

export const EditClientForm = styled.form`
  width: 100%;
  max-width: 100%;
  margin: 0;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  @media (max-width: 500px) {
    max-width: 100vw;
    padding: 12px 4vw 20px 4vw;
  }
`;

export const EditClientInputGroup = styled.div`
  width: 100%;
  text-align: left;

  & .ant-select,
  & .ant-picker,
  & .ant-input-number {
    width: 100%;
  }

  & .ant-input[disabled] {
    background: var(--yrm-surface-3);
    color: rgba(0, 0, 0, 0.75);
  }
`;

export const Flex = styled.div`
  display: flex;
  flex-direction: column;
`;

/* Labels e títulos mais compactos */
export const LabelTitle = styled.h4`
  margin: 6px 0 6px;
  font-size: 14px;
  font-weight: 600;
  color: var(--yrm-text-2);
`;

export const EditClientInput = styled.div`
  width: 100%;
`;

export const EditClientOptions = styled.div`
  margin-bottom: 2rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 384px) {
    & button {
      margin-top: 12px;
      margin-left: auto;
    }
  }
`;

export const EditClientError = styled.p`
  text-align: center;
  color: #dc3545;
  margin-top: 1rem;
  margin-bottom: 1rem;

  @media (max-width: 361px) {
    font-size: 14px;
  }
`;

export const EditClientFooter = styled.p`
  text-align: center;
  margin-bottom: 0;
  margin-top: 3rem;

  @media (max-width: 361px) {
    font-size: 14px;
  }
`;

/* Footer do Drawer: botão principal arredondado e aparência escura similar ao mockup */
export const DrawerFooterStyles = styled.div`
  .ant-drawer-footer {
    padding: 18px 24px !important;
    background: var(--yrm-surface);
    box-shadow: 0 -8px 18px rgba(5, 6, 20, 0.06);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .drawer-primary-btn {
    min-width: 160px;
    font-weight: 600;
  }

  .drawer-primary-btn:hover, .drawer-primary-btn:focus {
    opacity: 0.95;
    filter: brightness(0.98);
  }
`;
